<template>
    <label :class="[color, { 'lock': lock }]">
        <input type="checkbox" @change="toggle()" :checked="checked" />
        <span v-if="number">{{ number }}</span>
        <span v-else>
            <svg aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zM264 408c0 22.1-17.9 40-40 40s-40-17.9-40-40v-48c0-22.1 17.9-40 40-40s40 17.9 40 40v48z"></path></svg>
        </span>
        <svg aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512"><path fill="currentColor" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path></svg>
    </label>
</template>

<script>
export default {
    name: 'QwixxNumber',
    props: {
        color: {
            type: String,
            required: true,
            validator: v => ['red', 'yellow', 'green', 'blue'].indexOf(v) !== -1
        },
        number: Number,
        lock: Boolean
    },
    methods: {
        toggle: function() {
            this.$store.commit("toggle", { color: this.color, number: this.number });
        }
    },
    computed: {
        checked: function() {
            return this.$store.state.marks[this.color].indexOf(this.number) !== -1;
        }
    }
}
</script>

<style scoped>

label {
    padding: 1vw 0.5vw;
    position: relative;
}

label input {
    opacity: 0;
    position: absolute;
}
label input:checked ~ svg {
    display: block;
}

label svg {
    display: none;
    position: absolute;
    height: 100%;
    width: calc((100vw - 12vw) / 12 - 2vw);
    top: 0;
    left: 1.5vw;
    color: var(--nord0);
    opacity: .5;
}

span {
    width: 100%;
    height: calc((100vw - 12vw) / 12);

    background: rgba(255, 255, 255, 65%);
    border-radius: 1vw;

    font-size: 5vw;
    font-family: sans-serif;

    display: flex;
    align-items: center;
    justify-content: center;
}

label.lock span {
    border-radius: 50%;
}
label.lock span svg {
    display: block;
    position: initial;
    width: 3vw;
    color: inherit;
    opacity: 1;
}

.red {
    background: var(--color-red);
    color: var(--color-red);
}
.yellow {
    background: var(--color-yellow);
    color: var(--color-yellow);
}
.green {
    background: var(--color-green);
    color: var(--color-green);
}
.blue {
    background: var(--color-blue);
    color: var(--color-blue);
}

</style>
